export const TERMS_URL = '//www.feller.ch/de/nutzungsbedingungen';
export const FR_TERMS_URL = '//www.feller.ch/fr/conditions-dutilisation';
export const IT_TERMS_URL = '//www.feller.ch/it/condizioni-di-utilizzo';

export const PRIVACY_URL = '//www.feller.ch/de/privacy_notice_professional_users';
export const FR_PRIVACY_URL = '//www.feller.ch/fr/privacy_notice_professional_users';
export const IT_PRIVACY_URL = '//www.feller.ch/it/privacy_notice_professional_users';

export const PRIVACY_URL_END_USER = '//www.feller.ch/de/privacy_notice_private_users';
export const FR_PRIVACY_URL_END_USER = '//www.feller.ch/fr/privacy_notice_private_users';
export const IT_PRIVACY_URL_END_USER = '//www.feller.ch/it/privacy_notice_private_users';

export const LANGUAGE_TO_POLICY_URL = {
  en: PRIVACY_URL,
  de: PRIVACY_URL,
  fr: FR_PRIVACY_URL,
  it: IT_PRIVACY_URL,
};

export const LANGUAGE_TO_POLICY_URL_END = {
  en: PRIVACY_URL_END_USER,
  de: PRIVACY_URL_END_USER,
  fr: FR_PRIVACY_URL_END_USER,
  it: IT_PRIVACY_URL_END_USER,
};

export const LANGUAGE_TO_TERMS_URL = {
  en: TERMS_URL,
  de: TERMS_URL,
  fr: FR_TERMS_URL,
  it: IT_TERMS_URL,
};

export const ENGLISH_KEY = 'en';
export const GERMAN_KEY = 'de';

export const userNewsStatus = {
  SUBSCRIBED: 'subscribed',
  PENDING: 'pending',
  UNSUBSCRIBED: 'unsubscribed',
  NOT_SUBSCRIBED_YET: 'not_found',
};

export const adminRequestStatus = {
  OPEN: 'OPEN',
  APPROVED: 'APPROVED',
  DECLINED: 'DECLINED',
};

export const OPEN_MODAL_TIMEOUT = 1500;

export const DEBOUNCE_TIMEOUT = 500;

export const DEFAULT_DATA_LIMIT = 30;

export const TABLE_ROW_HEIGHT = 62;

export const END_USERS_ROLE = 'end-users';
export const PROFESSIONAL_USER_ROLE = 'professional-users';

export const FELLER_ADMIN = 'FellerAdmin';

export const signUpFromIndicator = {
  DISPO: 'DISPOSUITE',
  ACCOUNT: 'ACCOUNT',
  PORTAL: 'PORTAL',
  ESETUP: 'ESETUP',
  WISERHOME: 'WISERHOME',
  LERNETZ: 'LERNETZ',
};

export const DARK = 'dark';
export const LIGHT = 'light';

export const NO_COMPANY = 'no-company';
export const COMPANY_UID_NOT_FOUND = 'uid-not-found';

export const ROOT_PATH = '/';
export const AUTH0_ERROR_PATH = '/error-page';
export const CIAM_REGISTRATION_PATH = '/ciam-continue';

export const resendActions = {
  SMS: 'resend-sms',
  NEW_DEVICE_EMAIL: 'resend-new-device-email',
};
